const VideosTechno = [
  {
    video_id: "ei8true1HbQ",
    title: "Come Down (ARTBAT Remix)",
    artist: "Definition ft. Liu Bei",
  },
  {
    video_id: "lIg6lCWaIOs",
    title: "In My Mind",
    artist: "Pig&Dan",
  },
  {
    video_id: "qLVG3Je4Oho",
    title: "We All Love Chords",
    artist: "Andrea Oliva",
  },
  {
    video_id: "_EPWDYZhuoU",
    title: "Sewers",
    artist: "Gaga & Mateo!",
  },
  {
    video_id: "5GS20p6oaVw",
    title: "Dance Of Shadows",
    artist: "Mladen Tomic",
  },
  {
    video_id: "6C2CRYyM1IQ",
    title: "Pasta Lemon",
    artist: "Popof",
  },
  {
    video_id: "XeFh_JbB2ck",
    title: "Hurricane",
    artist: "Sidney Charles",
  },
  {
    video_id: "IjjtBro_m-8",
    title: "Assault",
    artist: "Miguel Bastida",
  },
  {
    video_id: "hm4SOpmB_zI",
    title: "Hang Up",
    artist: "Axel Karakasis",
  },
  {
    video_id: "iV0a89mZIs0",
    title: "Undertaker",
    artist: "Pedro Silva",
  },
  {
    video_id: "YERIXmNdp2I",
    title: "Enigma",
    artist: "Alex Mine",
  },
  {
    video_id: "xmLUqjooRgA",
    title: "Sub",
    artist: "D Unity",
  },
  {
    video_id: "JUn7byPNXTY",
    title: "Light Off",
    artist: "Hatsu, Angelo Raguso",
  },
  {
    video_id: "cakhpxo0WEE",
    title: "Shapeshifter",
    artist: "Schubert",
  },
  {
    video_id: "_R7n3A4padM",
    title: "Pitch Delay",
    artist: "Harvy Valencia, Niko Gualano",
  },
  {
    video_id: "jg_k1YvsVSY",
    title: "Jet Lag Slave",
    artist: "D-nox & Beckers",
  },
  {
    video_id: "b2RcZQNMy5s",
    title: "Conjure Dreams",
    artist: "Maceo Plex",
  },
  {
    video_id: "Lsi7d5e7Xg0",
    title: "Old Rustle",
    artist: "Sasha Carassi",
  },
  {
    video_id: "mShXbcSUUb8",
    title: "Forward Unto Dawn",
    artist: "Dustin Zahn",
  },
  {
    video_id: "FNi3GEwqpcA",
    title: "Into The Light",
    artist: "Monika Kruse, Pig & Dan",
  },
  {
    video_id: "TAz6XI-19hg",
    title: "Ross Island",
    artist: "Mateo!",
  },
  {
    video_id: "GVp-UOEur6Y",
    title: "Wir",
    artist: "Stephan Bodzin",
  },
  {
    video_id: "BbxDycGoDCY",
    title: "The People",
    artist: "Sean Collier",
  },
  {
    video_id: "sF9qmSpqX-c",
    title: "Try",
    artist: "Monoloc",
  },
  {
    video_id: "Eq8gwzD1hOE",
    title: "You Are Sleeping (Matador Remix)",
    artist: "PQM",
  },
  {
    video_id: "v1txX1Q3Pb8",
    title: "Vagenda",
    artist: "Matador",
  },
  {
    video_id: "Ef3OQsVixWc",
    title: "Remain",
    artist: "Slam",
  },
  {
    video_id: "tsQXDwzLRYo",
    title: "Pech",
    artist: "Oliver Huntemann",
  },
  {
    video_id: "Bjk3LFXjeNw",
    title: "Tight Laces",
    artist: "Loco Dice",
  },
  {
    video_id: "Bc9TJ7e5yUA",
    title: "Astm E",
    artist: "Iry",
  },
  {
    video_id: "Dh-BByORT5o",
    title: "Trending (Fhaken Remix)",
    artist: "James Hopkins",
  },
  {
    video_id: "CnxoyCVCSOE",
    title: "Panic Control",
    artist: "Landmark",
  },
  {
    video_id: "HpIkBkGz6-w",
    title: "These Walls are Made of Water (Pan-Pot Remix)",
    artist: "Nicole Moudaber & Skin",
  },
  {
    video_id: "WaMsd_dVa6E",
    title: "Broken Engine (Wigbert Deeper Remix)",
    artist: "Pan-Pot",
  },
];

export default VideosTechno;
